import apiService from '../../services/api.service';
import firebaseService from '../../services/firebase.service';

// action types
export const FETCH_REPORT = 'fetchReport';
export const UPLOAD_TEMP_PDF = 'UploadTempPdf';
export const CHANGE_COMPONENT = 'changeComponent';
export const SAVE_TEMP_PIC_FILE = 'saveTempPicFile';
export const SAVE_TEMP_PDF_FILE = 'saveTempPdfFile';
export const VERIFY_REPORT_HASH = 'verifyReportHashFromBlockchain';
export const SAVE_REPORT_FIELDS = 'saveReportFields';
export const CLEAN_REPORT_FIELDS = 'clearReportFields';
export const CHANGE_COMPILE_STEP = 'changeCompileStep';
export const SAVE_REPORT_TO_DATABASE = 'saveReportToDatabase';
export const SAVE_REPORT_TO_BLOCKCHAIN = 'saveReportHashToBlockchain';

// mutation types
const SET_REPORTS = 'setReports';
const SET_COMPILE_STEP = 'setCompileStep';
const SET_TEMP_PIC_FILE = 'setTempPicFile';
const SET_TEMP_PDF_FILE = 'setTempPdfFile';
const SET_REPORT_FIELDS = 'saveReportFields';
const SET_ACTIVE_COMPONENT = 'setActiveComponent';
const RESET_REPORT_FIELDS = 'resetReportFields';
const SET_FETCHED_REPORT_DATA = 'setFetchedInvaitationReport';


const state = {
   reports: [],
   compileStep: 0,
   tempPdfFile: null,
   tempPicFile: null,
   reportFields: {}, // all report form fields state
   invitationData: [],
   activeComponent: 'appReportInit',
   fetchedReportData: {},
   fetchedInvitationData: {}
};

const getters = {
   reports: (state) => {
      return state.reports;
   },
   reportFields: (state) => {
      return state.reportFields;
   },
   compileStep: (state) => {
      return state.compileStep;
   },
   activeComponent: (state) => {
      return state.activeComponent;
   },
   tempPdfFile: (state) => {
      return state.tempPdfFile;
   },
   tempPicFile: (state) => {
      return state.tempPicFile;
   },
   fetchedReportData: (state) => {
      return state.fetchedReportData;
   }
};

const mutations = {
   [SET_ACTIVE_COMPONENT](state, component) {
      state.activeComponent = component;
   },
   [SET_COMPILE_STEP](state, component) {
      state.compileStep = component;
   },
   [SET_REPORTS](state, reports) {
      state.reports = reports;
   },
   [SET_REPORT_FIELDS](state, fields) {
      state.reportFields = fields;
   },
   [RESET_REPORT_FIELDS](state) {
      state.reportFields = {};
   },
   [SET_TEMP_PDF_FILE](state, file) {
      state.tempPdfFile = file;
   },
   [SET_TEMP_PIC_FILE](state, file) {
      state.tempPicFile = file;
   },
   [SET_FETCHED_REPORT_DATA](state, data) {
      state.fetchedReportData = data;
   }
};

const actions = {
   [CHANGE_COMPONENT](context, component) {
      context.commit(SET_ACTIVE_COMPONENT, component);
   },
   [CHANGE_COMPILE_STEP](context, step) {
      context.commit(SET_COMPILE_STEP, step);
   },
   [SAVE_REPORT_FIELDS](context, fields) {
      context.commit(SET_REPORT_FIELDS, fields);
   },
   [SAVE_TEMP_PDF_FILE](context, file) {
      context.commit(SET_TEMP_PDF_FILE, file);
   },
   [SAVE_TEMP_PIC_FILE](context, file) {
      context.commit(SET_TEMP_PIC_FILE, file);
   },
   [CLEAN_REPORT_FIELDS](context) {
      context.commit(RESET_REPORT_FIELDS);
   },
   [SAVE_REPORT_TO_BLOCKCHAIN](context) {
      return new Promise((resolve, reject) => {
         apiService.setWeb3AsBaseUrl();
         const data = {
            "userToken": context.getters.user.uid,
            "reportHash": context.getters.reportFields.captured_file_hash
         };
         apiService.post('/v1/save/report', data).then((res) => {
            context.getters.reportFields.transaction_hash = res.data.message;
            context.commit(SAVE_REPORT_FIELDS, context.state.reportFields);
            resolve(res.data);
         }).catch((err) => {
            reject(`[saveReportHashToBlockchain] => ${err}`);
         })
      });
   },
   [SAVE_REPORT_TO_DATABASE](context) {
      return new Promise((resolve, reject) => {
         const data = context.getters.reportFields;
         firebaseService.registerReport(data).then((res) => {
            context.commit(SET_REPORT_FIELDS, data);
            resolve(res);
         }).catch((err) => {
            reject(`[saveReport] => ${err}`)
         })
      });
   },
   [VERIFY_REPORT_HASH](context, report_hash) {
      return new Promise((resolve, reject) => {
         apiService.setWeb3AsBaseUrl();
         apiService.get(`/v1/get/report?report_hash=${report_hash}`).then((res) => {
            resolve(res.data);
         }).catch((err) => {
            reject(`[verifyScreenshotReportHash] => ${err}`)
         })
      })
   },
   [UPLOAD_TEMP_PDF](context, folder) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         formdata.append('file', context.getters.tempPdfFile);
         formdata.append('folder', folder);
         apiService.setPdfApiAsBaseUrl();
         apiService.post('/pdf/upload', formdata).then((res) => {
            context.commit(SET_TEMP_PDF_FILE, null);
            context.state.reportFields.source_id = res.data.id;
            context.state.reportFields.source = res.data.url;
            resolve(res.data);
         }).catch((err) => {
            context.commit(SET_TEMP_PDF_FILE, null);
            reject(`[uploadTempPdf] => ${err}`)
         });
      });
   },
   [FETCH_REPORT](context, id) {
      firebaseService.fetchReports(id).then((res) => {
         context.commit(SET_REPORTS, res);
      }).catch((err) => {
         console.error(`[fetchReport] => ${err}`);
      })
   },
};

export default {
   state,
   getters,
   mutations,
   actions,
}

